import axios from 'axios'

export default {
    namespaced: true,

    state: {
        suggestedCalories: null,
        individuals: [],
        guests: [],
    },

    actions: {
        addIndividual({commit},value) {
          axios({
            method: 'post',
            url: value[0],
            data: {
              request:
                "post_family_member @email=\"" + value[1][0] + "\""
                + ", @name=\"" + value[1][1] + "\""
                + ", @gender=\"" + value[1][2] + "\""
                + ", @birthYear=\"" + value[1][3] + "\""
                + ", @weight=\"" + value[1][4] + "\""
                + ", @height=\"" + value[1][5] + "\""
                + ", @activity=\"" + value[1][6] + "\""
                + ", @goal=\"" + value[1][7] + "\""
                + ", @dailyCalorieTarget=\"" + value[1][8] + "\""
                + ", @suggestedCalories=\"" + value[1][9] + "\""
            }
          })
          .then(response => {
            console.log('addIndividual:',response);
            commit('loadIndividuals',[value[1][0],value[0]]);
          })
          .catch(error => {
            console.log(error)
          })
          
          commit('resetSuggestedCalories');
        },

        updateIndividual({commit},value) {
          axios({
            method: 'post',
            url: value[0],
            data: {
              request:
              "post_update_family_member @email=\"" + value[1][0] + "\""
              + ", @name=\"" + value[1][1] + "\""
              + ", @gender=\"" + value[1][2] + "\""
              + ", @birthYear=\"" + value[1][3] + "\""
              + ", @weight=\"" + value[1][4] + "\""
              + ", @height=\"" + value[1][5] + "\""
              + ", @activity=\"" + value[1][6] + "\""
              + ", @goal=\"" + value[1][7] + "\""
              + ", @dailyCalorieTarget=\"" + value[1][8] + "\""
              + ", @suggestedCalories=\"" + value[1][9] + "\""
            }
          })
          .then(response => {
            console.log('updateIndividual:',response);
          })
          .catch(error => {
            console.log(error)
          })
          
          commit('resetSuggestedCalories');
        },

        removeIndividual({commit},value) {
          axios({
            method: 'post',
            url: value[0],
            data: {
              request:
              "post_remove_family_member @email=\"" + value[1][0] + "\""
              + ", @name=\"" + value[1][1] + "\""
            }
          })
          .then(response => {
            console.log('removeIndividual:',response);
          })
          .catch(error => {
            console.log(error)
          })

          commit('loadIndividuals',[value[1][0],value[0]]);
          commit('resetSuggestedCalories');
        },

        familyChangeMade({commit},value) {
          commit('familyChangeMade',value);
          commit('suggestedCalories',[value[0],'family']);
        },

        addGuest({commit},value) {
            commit('addGuest',value);
            commit('resetSuggestedCalories');
        },
        
        updateGuest({commit},value) {
            commit('updateGuest',value);
        },

        guestChangeMade({commit},value) {
            commit('guestChangeMade',value);
            commit('suggestedCalories',[value,'guest']);
        },

        updateSuggestedCalories({commit},value) {
            commit('suggestedCalories',[0,'other',value]);
        },

        resetSuggestedCalories({commit}) {
            commit('resetSuggestedCalories')
        }

    },

    mutations: {
      loadIndividuals(state,value) {
          axios({
            method: 'post',
            url: value[1],
            data: {
              request:
                "get_individuals @email=\"" + value[0] + "\""
            }
          })
          .then(response => {
            console.log('loadIndividuals:',response);
            state.individuals = response.data.body;
          })
          .catch(error => {
            console.log(error)
          })
        },

        individualChangeMade(state,value) {
          console.log('individualChangeMade:',value);
          state.individuals[value[0]].needToSave = value[1];
        },

        loadGuests(state,value) {
          axios({
            method: 'post',
            url: value[1],
            data: {
              request:
                "get_guests @email=\"" + value[0] + "\""
            }
          })
          .then(response => {
            console.log('loadGuests:',response);
            state.guests = response.data.body;
          })
          .catch(error => {
            console.log(error)
          })
        },
           
        addGuest(state,value) {
            state.guests.push(
                {
                    "name": value[0],
                    "gender": value[1],
                    "birth_year": value[2],
                    "weight_lb": value[3],
                    "height_in": value[4],
                    "activity_level": value[5],
                    "weight_goal": value[6],
                    "daily_calorie_target": value[7],
                    "suggested_calories": value[8],
                    "needToSave": false
                }
            )
        },
        updateGuest(state,value) {
            state.guests[value[0]].name = value[1];
            state.guests[value[0]].gender = value[2];
            state.guests[value[0]].birthYear = value[3];
            state.guests[value[0]].weight = value[4];
            state.guests[value[0]].height = value[5];
            state.guests[value[0]].weeklyWorkouts = value[6];
            state.guests[value[0]].weightGoal = value[7];
            state.guests[value[0]].targetCalories = value[8];
            state.guests[value[0]].needToSave = false;
        },


        guestChangeMade(state,value) {
            state.guest[value].needToSave = true;            
        },

        resetSuggestedCalories(state) {
            state.suggestedCalories = null;
        },

        suggestedCalories(state,value) {
          // console.log('-----------------------------');
          // console.log('suggestedCalories value:',value);
          // console.log('-----------------------------');

            let response = null;
            let gender = null;
            let birthYear = null;
            let weight = null;
            let height = null;
            let activityLevel = null;
            let weightGoal = null;
            
            
            if (value[1] == 'guest') {
              if (state.guests[value[0]].gender == 'Male' | state.guests[value[0]].gender == 'M') {
                gender = 'M'
              } else if (state.guests[value[0]].gender == 'Female' | state.guests[value[0]].gender == 'F') {
                gender = 'F'
              }
              birthYear = state.guests[value[0]].birthYear;
              weight = state.guests[value[0]].weight;
              height = state.guests[value[0]].height;
              activityLevel = state.guests[value[0]].activityLevel;
              weightGoal = state.guests[value[0]].weightGoal;
            } else if (value[1] == 'family') {
              if (state.individuals[value[0]].gender == 'Male' | state.individuals[value[0]].gender == 'M') {
                gender = 'M'
              } else if (state.individuals[value[0]].gender == 'Female' | state.individuals[value[0]].gender == 'F') {
                gender = 'F'
              }
              birthYear = state.individuals[value[0]].birth_year;
              weight = state.individuals[value[0]].weight_lb;
              height = state.individuals[value[0]].height_in;
              activityLevel = state.individuals[value[0]].activity_level;
              weightGoal = state.individuals[value[0]].weight_goal;
            } else {
              if (value[2].gender == 'Male' | value[2].gender == 'M') {
                gender = 'M'
              } else if (value[2].gender == 'Female' | value[2].gender == 'F') {
                gender = 'F'
              }
              birthYear = value[2].birthYear;
              weight = value[2].weight;
              height = value[2].height;
              activityLevel = value[2].activityLevel;
              weightGoal = value[2].weightGoal;
            }
            
            let age = (new Date().getFullYear() - birthYear);

            // console.log('-----------------------------');
            // console.log('gender:', gender);
            // console.log('age:', age);
            // console.log('weight',weight);
            // console.log('height',height);
            // console.log('activityLevel',activityLevel);
            // console.log('weightGoal',weightGoal);
            // console.log('-----------------------------');
            
            if(age >= 16){

              if(
                gender != null &&
                birthYear != null &&
                weight != null &&
                height != null &&
                activityLevel != null &&
                weightGoal != null
              ) {
                response = (
                    weight * 4.531393
                    + height * 15.875
                    - age * 4.92
                );
      
                if(gender == "F") {
                    response -= 161
                } else {
                    response += 5}
                
                if(activityLevel == 'sedentary') {
                    response *= 1.2
                } else if (activityLevel == 'light') {
                    response *= 1.375
                } else if (activityLevel == 'active') {
                    response *= 1.55
                } else if (activityLevel == 'very active') {
                    response *= 1.725
                }
      
                if(weightGoal == 'Gain 1 lb' | weightGoal == 'gain') {
                    response += 500
                } else if (weightGoal == 'Gain 1/2 lb') {
                    response += 250
                } else if (weightGoal == 'Lose 1/2 lb') {
                    response -= 250
                } else if (weightGoal == 'Lose 1 lb' | weightGoal == 'lose') {
                    response -= 500
                }
                
                response = Math.round(response);

              }
            } else if(age == 2) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1000
                } else if (activityLevel == 'active') {
                  response = 1000
                } else if (activityLevel == 'bery active') {
                  response = 1000
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1000
                } else if (activityLevel == 'active') {
                  response = 1000
                } else if (activityLevel == 'very active') {
                  response = 1000
                }
              }
      
            } else if (age == 3) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1000
                } else if (activityLevel == 'active') {
                  response = 1400
                } else if (activityLevel == 'very active') {
                  response = 1400
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1000
                } else if (activityLevel == 'active') {
                  response = 1200
                } else if (activityLevel == 'very active') {
                  response = 1400
                }
              }
      
            } else if (age == 4) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1200
                } else if (activityLevel == 'active') {
                  response = 1400
                } else if (activityLevel == 'very active') {
                  response = 1600
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1200
                } else if (activityLevel == 'active') {
                  response = 1400
                } else if (activityLevel == 'very active') {
                  response = 1400
                }
              }
      
            } else if (age == 5) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1200
                } else if (activityLevel == 'active') {
                  response = 1400
                } else if (activityLevel == 'very active') {
                  response = 1600
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1200
                } else if (activityLevel == 'active') {
                  response = 1400
                } else if (activityLevel == 'very active') {
                  response = 1600
                }
              }
      
            } else if (age == 6) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1400
                } else if (activityLevel == 'active') {
                  response = 1600
                } else if (activityLevel == 'very active') {
                  response = 1800
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1200
                } else if (activityLevel == 'active') {
                  response = 1400
                } else if (activityLevel == 'very active') {
                  response = 1600
                }
              }
      
            } else if (age == 7) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1400
                } else if (activityLevel == 'active') {
                  response = 1600
                } else if (activityLevel == 'very active') {
                  response = 1800
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1200
                } else if (activityLevel == 'active') {
                  response = 1600
                } else if (activityLevel == 'very active') {
                  response = 1800
                }
              }
      
            } else if (age == 8) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1400
                } else if (activityLevel == 'active') {
                  response = 1600
                } else if (activityLevel == 'very active') {
                  response = 2000
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1400
                } else if (activityLevel == 'active') {
                  response = 1600
                } else if (activityLevel == 'very active') {
                  response = 1800
                }
              }
      
            } else if (age == 9) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1600
                } else if (activityLevel == 'active') {
                  response = 1800
                } else if (activityLevel == 'very active') {
                  response = 2000
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1400
                } else if (activityLevel == 'active') {
                  response = 1600
                } else if (activityLevel == 'very active') {
                  response = 1800
                }
              }
      
            } else if (age == 10) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1600
                } else if (activityLevel == 'active') {
                  response = 1800
                } else if (activityLevel == 'very active') {
                  response = 2200
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1400
                } else if (activityLevel == 'active') {
                  response = 1800
                } else if (activityLevel == 'very active') {
                  response = 2000
                }
              }
      
            } else if (age == 11) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1800
                } else if (activityLevel == 'active') {
                  response = 2000
                } else if (activityLevel == 'very active') {
                  response = 2200
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1600
                } else if (activityLevel == 'active') {
                  response = 1800
                } else if (activityLevel == 'very active') {
                  response = 2000
                }
              }
      
            } else if (age == 12) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1800
                } else if (activityLevel == 'active') {
                  response = 2200
                } else if (activityLevel == 'very active') {
                  response = 2400
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1600
                } else if (activityLevel == 'active') {
                  response = 2000
                } else if (activityLevel == 'very active') {
                  response = 2200
                }
              }
      
            } else if (age == 13) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 2000
                } else if (activityLevel == 'active') {
                  response = 2200
                } else if (activityLevel == 'very active') {
                  response = 2600
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1600
                } else if (activityLevel == 'active') {
                  response = 2000
                } else if (activityLevel == 'very active') {
                  response = 2200
                }
              }
      
            } else if (age == 14) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 2000
                } else if (activityLevel == 'active') {
                  return 2400
                } else if (activityLevel == 'very active') {
                  response = 2800
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1800
                } else if (activityLevel == 'active') {
                  response = 2000
                } else if (activityLevel == 'very active') {
                  response = 2400
                }
              }
              
            } else if (age == 15) {
              if(gender == 'M') {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 2200
                } else if (activityLevel == 'active') {
                  response = 2600
                } else if (activityLevel == 'very active') {
                  response = 3000
                }
              } else {
                if(activityLevel == 'sedentary' || activityLevel == 'light') {
                  response = 1800
                } else if (activityLevel == 'active') {
                  response = 2000
                } else if (activityLevel == 'very active') {
                  response = 2400
                }
              }
            }
            
            if (value[1] == 'guest') {
                state.guests[value[0]].suggestedCalories = response
            } else if (value[1] == 'family') {
                state.individuals[value[0]].suggested_calories = response
            } else {
                state.suggestedCalories = response
            }
        }
    },

    getters: {
        individuals(state) {
            return state.individuals
        },
        guests(state) {
            return state.guests
        },
        suggestedCalories(state) {
            return state.suggestedCalories
        }
    }

}
